import Load from 'components/Load';
import { createNavigationalRoute } from 'modules/app/components/NavigationalLayout';
import AppBottomPushDown from 'modules/common/Navbar/PushDown/AppBottomPushDown';
import Notfound from 'modules/errorpages/Notfound';
import React from 'react';
import { Route, Routes, useParams } from 'react-router-dom';
import { RouteDescriptor, createRouteHandle } from 'routing/types';
import basePath from 'utils/basePath';

import TransferBookingModals from './TransferBookingModals';
import { TransferBookingContextProvider } from './context/TransferBookingContext';

const TransferBooking = Load(
  () =>
    import(
      /* webpackChunkName: "host-transfer-booking" */ './TransferBookingPage'
    ),
);

const base = `${basePath}/host/transfer-booking/:transferRequestId`;

export const hostTransferBookingRootRoute: RouteDescriptor = {
  id: 'host-transfer-booking.root',
  path: `${base}/*`,
  label: 'Host Transfer Booking',
  audience: 'host',
  layout: 'navigational',
  module: 'host-transfer-booking',
};

export const hostTransferBookingRoute: RouteDescriptor = {
  id: 'host-transfer-booking.detail',
  path: `${base}/`,
  label: 'Host Transfer Booking Detail',
  audience: 'host',
  layout: 'navigational',
  module: 'host-transfer-booking',
};

const SubRoutes = () => {
  const { transferRequestId } = useParams<{ transferRequestId: string }>();

  return (
    <TransferBookingContextProvider transferRequestId={transferRequestId}>
      <Routes>
        {createNavigationalRoute({
          key: hostTransferBookingRoute.id,
          id: hostTransferBookingRoute.id,
          index: true,
          hideFooter: true,
          noNavbar: true,
          showZendesk: false,
          component: TransferBooking as any,
          handle: createRouteHandle(hostTransferBookingRoute),
        })}
        <Route path="*" element={<Notfound />} />
      </Routes>
      <TransferBookingModals />
    </TransferBookingContextProvider>
  );
};

const HostTransferBookingRoutes = () => (
  <>
    <SubRoutes />
    <AppBottomPushDown />
  </>
);

export const hostTransferBookingRoutes = [
  <Route
    key={hostTransferBookingRootRoute.id}
    id={hostTransferBookingRootRoute.id}
    path={hostTransferBookingRootRoute.path}
    handle={createRouteHandle(hostTransferBookingRootRoute)}
    element={<HostTransferBookingRoutes />}
  />,
];

export const hostTransferBookingRouteDescriptors = [
  hostTransferBookingRootRoute,
  hostTransferBookingRoute,
];

export default hostTransferBookingRoutes;
